import Repository from "../../repository";

export default {
    Get: (payload) => Repository.post(`/api/DebitGasValues/Get`, payload),
    GetById: (payload) => Repository.post(`/api/DebitGasValues/GetById`, payload),
    Add: (payload) => Repository.post(`/api/DebitGasValues/Add`, payload),
    Delete: (payload) => Repository.post(`/api/DebitGasValues/Delete`, payload),
}
